import _ from 'lodash'
import { put, select, takeLatest } from 'redux-saga/effects'

import {
  editRiderSelectedPlan,
  updateSelectedPlan,
  editSumAssured,
  editRiderSumAssured,
} from 'quick-quote/product-common/coverage-plan/actions'
import { getSelectedDisplayProduct } from 'quick-quote/product-selection/selectors'
import { editCampaignPlan, SELECT_SUKHAPABDEKDEE_PLAN } from 'quick-quote/product-sukhapabdekdee/actions'

export function createProductSukhapabDekDeeFunc() {
  const selectSukhapabDekDeePlan = function*(action) {
    const selectedPlanCode = action.payload
    const displayProduct = yield select(getSelectedDisplayProduct)
    const plans = displayProduct.plans
    const selectedPlan = plans.find((v) => v.planCode === selectedPlanCode)
    if (selectedPlan) {
      displayProduct.selectedCampaignPlan = selectedPlanCode
      yield put(editCampaignPlan(displayProduct))
      yield put(editSumAssured(_.get(selectedPlan, 'sumAssured')))
      yield put(updateSelectedPlan(selectedPlanCode))

      for (let rider of selectedPlan.riders) {
        yield put(editRiderSelectedPlan(rider.code, { planCode: rider.planCode }))
        yield put(editRiderSumAssured(rider.code, rider.sumAssured))
      }
    }
  }

  return {
    selectSukhapabDekDeePlan,
  }
}

/**
 * @param serviceWrapper {Awaited<ReturnType<import('core/service-wrapper/wrapper').buildServiceWrapper>>}
 */
export function* watchers(serviceWrapper) {
  const { SUKHAPABDEKDEE } = serviceWrapper.products
  yield [takeLatest([SELECT_SUKHAPABDEKDEE_PLAN], SUKHAPABDEKDEE.onUpdateSelectedBasicPlan)]
}

export const sagas = watchers
